import React from "react";
import clsx from "clsx";
import DateHelper from "../../DateHelper/DateHelper";
import DatePickerInput from "../../DatePickerInput/DatePickerInput";
import NumberInput from "../../NumberInput/NumberInput";
import GroupContractBuilderErrors from "../GroupContractBuilderErrors";
import TimePickerInput from "../../TimePickerInput/TimePickerInput";
import { subDays, addDays, isAfter, isBefore } from "date-fns";

class GroupContractBuilderGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      numberFormat:
        "0" +
        ($("#delimiter").val() || ",") +
        "0" +
        ($("#separator").val() || ".") +
        "00",
      dateFormat: DateHelper.rubyToDateJS(this.props.date_format),
      timeFormat: DateHelper.rubyToDateJS(this.props.time_format),
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeEditor = this.onChangeEditor.bind(this);
    this.onChangeStartDate = this.onChangeStartDate.bind(this);
    this.onChangeEndDate = this.onChangeEndDate.bind(this);
    this.onChangeCheckInTime = this.onChangeCheckInTime.bind(this);
    this.onChangeCheckOutTime = this.onChangeCheckOutTime.bind(this);
  }

  render() {
    var tabClasses = clsx({
      active: this.props.active_tab == "general",
      "tab-pane": true,
    });
    return (
      <div className={tabClasses} id="general">
        {this.renderErrors()}
        <div className="row">
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                {`${I18n.t("code")}*`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("group_contract_code_helper_text")}
                ></span>
              </label>
              {this.props.read_only ? (
                <div>{this.props.code}</div>
              ) : (
                <div style={{ width: "130px" }}>
                  <input
                    type="text"
                    name="code"
                    maxLength="12"
                    value={this.props.code}
                    onChange={this.onChange}
                    className={this.renderFieldClasses("code")}
                    data-model="Rate"
                    data-column="code"
                  />
                  {this.renderFieldErrors("code")}
                </div>
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group">
              <label>
                {`${I18n.t("name")}*`}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("group_contract_name_helper_text")}
                ></span>
              </label>
              {this.props.read_only ? (
                <div>{this.props.name}</div>
              ) : (
                <div>
                  <input
                    type="text"
                    name="name"
                    value={this.props.name}
                    onChange={this.onChange}
                    className={this.renderFieldClasses("name")}
                  />
                  {this.renderFieldErrors("name")}
                </div>
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>
                {I18n.t("begins")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("group_contract_start_date_helper_text")}
                ></span>
              </label>
              {this.props.read_only ? (
                <div>
                  {this.props.start_date.toString(this.state.dateFormat)}
                </div>
              ) : (
                <DatePickerInput
                  selectedDate={this.props.start_date || ""}
                  dateFormat={this.props.date_format}
                  onChange={this.onChangeStartDate}
                />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>
                {I18n.t("ends")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("group_contract_end_date_helper_text")}
                ></span>
              </label>
              {this.props.read_only ? (
                <div>{this.props.end_date.toString(this.state.dateFormat)}</div>
              ) : (
                <DatePickerInput
                  selectedDate={this.props.end_date || ""}
                  dateFormat={this.props.date_format}
                  onChange={this.onChangeEndDate}
                />
              )}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>
                {I18n.t("minimum_stay")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("minimum_stay_helper_text")}
                ></span>
              </label>
              {this.props.read_only ? (
                <div>{this.props.minimum_stay}</div>
              ) : (
                <NumberInput
                  min={0}
                  name="minimum_stay"
                  className="form-control"
                  onChange={this.onChange}
                  value={this.props.minimum_stay}
                />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>
                {I18n.t("maximum_stay")}{" "}
                <span
                  className="ss-help help"
                  title={I18n.t("maximum_stay_helper_text")}
                ></span>
              </label>
              {this.props.read_only ? (
                <div>{this.props.maximum_stay}</div>
              ) : (
                <NumberInput
                  min={0}
                  name="maximum_stay"
                  className="form-control"
                  onChange={this.onChange}
                  value={this.props.maximum_stay}
                />
              )}
            </div>
          </div>
          {/*<div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("check_in_time")}</label>
              {this.props.read_only ? (
                <div>
                  {this.props.check_in_time
                    ? DateHelper.parse(this.props.check_in_time).toString(
                        this.state.timeFormat
                      )
                    : null}
                </div>
              ) : (
                <TimePickerInput
                  onChange={this.onChangeCheckInTime}
                  selectedTime={this.props.check_in_time}
                  timeFormat={this.props.time_format}
                />
              )}
            </div>
          </div>
          <div className="col-sm-3">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <label>{I18n.t("check_out_time")}</label>
              {this.props.read_only ? (
                <div>
                  {this.props.check_out_time
                    ? DateHelper.parse(this.props.check_out_time).toString(
                        this.state.timeFormat
                      )
                    : null}
                </div>
              ) : (
                <TimePickerInput
                  onChange={this.onChangeCheckOutTime}
                  selectedTime={this.props.check_out_time}
                  timeFormat={this.props.time_format}
                />
              )}
            </div>
              </div>*/}
        </div>
      </div>
    );
  }

  renderErrors() {
    var errors = GroupContractBuilderErrors.general(this.props.errors);

    if (errors && errors.length) {
      var idx = 0;
      var errors = errors.map((error) => {
        idx = idx + 1;
        return <li key={error + idx}>{error}</li>;
      });

      return (
        <div className="alert alert-danger">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldErrors(field) {
    if (this.props.errors && this.props.errors[field]) {
      var idx = 0;
      var errors = this.props.errors[field].map((error) => {
        idx = idx + 1;
        return (
          <li key={idx}>
            <b>&#x2022;</b>
            {`${field}`} {error}
          </li>
        );
      });
      return (
        <div className="help-block">
          <ul>{errors}</ul>
        </div>
      );
    }
  }

  renderFieldClasses(field) {
    var classname = "form-control";
    if (
      this.props.errors &&
      Object.keys(this.props.errors).length &&
      this.props.errors[field]
    ) {
      classname = classname + " has-errors";
    }
    return classname;
  }

  onChange(event) {
    if (typeof this.props.onChange == "function") {
      this.props.onChange(event);
    }
  }

  onChangeEditor() {
    if (this.props.onChange) {
      this.props.onChange({
        target: {
          name: "description",
          value: this.getEditorHTML(),
        },
      });
    }
  }

  onChangeStartDate(startDate) {
    if (isBefore(this.props.end_date, startDate)) {
      this.onChange({
        target: {
          name: "start_date",
          value: startDate,
        },
      });
      this.onChange({
        target: {
          name: "end_date",
          value: addDays(startDate, 1),
        },
      });
    } else {
      this.onChange({
        target: {
          name: "start_date",
          value: startDate,
        },
      });
    }
  }

  onChangeEndDate(endDate) {
    if (isAfter(this.props.start_date, endDate)) {
      this.onChange({
        target: {
          name: "start_date",
          value: subDays(endDate, 1),
        },
      });
      this.onChange({
        target: {
          name: "end_date",
          value: endDate,
        },
      });
    } else {
      this.onChange({
        target: {
          name: "end_date",
          value: endDate,
        },
      });
    }
  }

  onChangeCheckInTime(time) {
    this.onChange({
      target: {
        name: "check_in_time",
        value: time,
      },
    });
  }

  onChangeCheckOutTime(time) {
    this.onChange({
      target: {
        name: "check_out_time",
        value: time,
      },
    });
  }
}
export default GroupContractBuilderGeneral;
